/**
 * KBArticleStatusService
 * Route: api/kb-article-statuses
 */
import { BaseService } from '../base/BaseService';
export class KBArticleStatusService extends BaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? KBArticleStatusService.DEFAULT_SERVICE_PATH,
            basePath: KBArticleStatusService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    async getAll() {
        const response = await this.getAllRaw();
        return response.data ?? [];
    }
    getAllRaw() {
        return this.http.get(this.buildUrl(''));
    }
    async getById(id) {
        const response = await this.http.get(this.buildUrl(`${id}`));
        return response.data ?? null;
    }
    async create(item) {
        const response = await this.http.post(this.buildUrl(''), item);
        return response.data ?? null;
    }
    async update(id, item) {
        const response = await this.http.put(this.buildUrl(`${id}`), item);
        return response.data ?? null;
    }
    async delete(id) {
        const response = await this.http.delete(this.buildUrl(`${id}`));
        return response.success;
    }
}
KBArticleStatusService.DEFAULT_SERVICE_PATH = 'resources';
KBArticleStatusService.BASE_PATH = 'api/kb-article-statuses';
//# sourceMappingURL=KBArticleStatusService.js.map